import { useAtsAdminCandidateFormCreateOrganizationAnonymousSessionMutation } from './graphql/create-organization-anonymous-session.v5.generated';

export const useCreateOrganizationAnonymousSession = () =>
  useAtsAdminCandidateFormCreateOrganizationAnonymousSessionMutation({
    context: {
      clientName: 'v5',
    },
  });
